export const menuHighlightDefaultColor = '#F73D3C';

export const defaultIconBgColor = '#4d4d4d';
